import BtDialog from './BtDialog'

export { BtDialog }
export default BtDialog
